import { connect } from "react-redux";

import VerifyOtp from "./verifyOtp";
import { AppState } from "../../core/reducers/rootReducer";
import * as otpActionTypes from "../../core/actionTypes/otpActionTypes";
import * as successActionTypes from "../../core/actionTypes/successActionTypes";
import * as profileActionTypes from "../../core/actionTypes/profileDetailsActionTypes";
import { Dispatch } from "react";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";
import { generateOtp, verifyOtp } from "../../core/actionCreators/otpActionCreators";
import { submitARCApprove } from "../../core/actionCreators/successActionCreators";
import { getAumDetails } from "../../core/actionCreators/profileDetailsActionCreators";

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    profileDetails: state.profileDetails,
    otpDetails: state.otpReducer,
    arcApproveDetails: state.success,
    isLoading: state.isLoading[otpActionTypes.GENERATE_OTP] || state.isLoading[otpActionTypes.VERIFY_OTP] || state.isLoading[successActionTypes.SUBMIT_ARC_APPROVE] || state.isLoading[profileActionTypes.AUM_MOBILE],
    isAuthenticated: isUserLoggedIn(txnId),
    partnerData: state.auth,
    error: state.error[otpActionTypes.GENERATE_OTP] || state.error[otpActionTypes.VERIFY_OTP] || state.error[successActionTypes.SUBMIT_ARC_APPROVE] || state.error[profileActionTypes.AUM_MOBILE],
    transactionDetails: state.transactionDetails,
  };
};


const mapDispatchToProps = (dispatch: Dispatch<otpActionTypes.OtpActions | successActionTypes.SuccessActions | profileActionTypes.ProfileActions>) => ({
  generateOtp: () => {
    dispatch(generateOtp())
  },
  verifyOtp: (request: object) => {
    dispatch(verifyOtp(request))
  },
  submitARCApprove: () => {
    dispatch(submitARCApprove())
  },
  getAumMobileDetails: () => {
    dispatch(getAumDetails())
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyOtp);
